module.exports = __webpack_public_path__ + "static/media/delete.d36bd4a7.svg";